import React from 'react'; 
const Gallery = () => { return <div style={{ padding: '120px 0', textAlign: 'center' }}><h1>Gallery - Coming Soon</h1></div>; }; 
export default Gallery; 
